import React from 'react';
import {Container, Grid} from '@material-ui/core';

import {homeData} from '../../values';

import {useStyles} from '../global/styles';
const Home = () => {
    const classes = useStyles()
    return (
        <div className={classes.backgroundHome}>
            <Container>
                <Grid container>
                    <Grid item xs={12} sm={6} className={classes.containerHome}>
                        <div className={classes.containerHomeImage}>
                            <img alt="Phone" src={homeData.image1} className={classes.phone} />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className={classes.containerHome2}>
                            <div>
                                <img alt="Rayas Logo" src={homeData.image2} className={classes.logo} />
                                <div className={classes.containerText}>
                                    <p className={classes.text} style={{ fontSize:16, fontWeight:600}}>{homeData.text1}</p>
                                </div>
                                <div className={classes.containerHome3}>
                                    <div className={classes.containerHome4}>
                                        <img alt="Icon Apple" src={homeData.icon} style={{width:30, paddingLeft:10}} />
                                        <label style={{paddingLeft:10, fontSize:25, fontWeight:600, cursor:'pointer', fontFamily:'Book',}}>{homeData.button}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};

export default Home;